'use client'

import Script from 'next/script'
import { useTermlyConsent } from '@/components/TermlyConsent/TermlyProvider'
import { commonEmailDomains } from '@/components/Tracking/commonEmailDomain'
import { TrackButtons } from '@/components/Tracking/TrackButtons'
import { TrackPageViews } from '@/components/Tracking/TrackPageViews'

// Moved away from @next/third-parties/GoogleAnalytics because
// it didn't allow us to pass the user ID and custom params
export function GoogleAnalytics({
  userId,
  gaId,
  email,
  debugMode,
}: {
  debugMode: boolean
  email: string | null
  userId: number | null
  gaId?: string | null
}) {
  const { consentRequired, consent } = useTermlyConsent()

  if (!gaId || (consentRequired && !consent?.analytics)) {
    return null
  }

  const emailDomain = email ? email.split('@')[1] : null
  const filteredEmailDomain =
    emailDomain && commonEmailDomains.includes(emailDomain) ? null : emailDomain

  return (
    <>
      <Script
        async
        id="_next-ga"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
      <Script id="_next-ga-init">
        {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${gaId}', ${JSON.stringify({
          debug_mode: debugMode,
          send_page_view: false,
          user_id: userId,
          user_properties: {
            email_domain: filteredEmailDomain,
          },
        })});
      `}
      </Script>
      <TrackButtons />
      <TrackPageViews />
    </>
  )
}
